import { render, staticRenderFns } from "./CompaniesTree.vue?vue&type=template&id=238b7085&scoped=true"
import script from "./CompaniesTree.vue?vue&type=script&lang=js"
export * from "./CompaniesTree.vue?vue&type=script&lang=js"
import style0 from "./CompaniesTree.vue?vue&type=style&index=0&id=238b7085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b7085",
  null
  
)

export default component.exports